import { router, usePage } from "@inertiajs/react"
import { Eye } from "lucide-react"
import { useEffect } from "react"

import type { Impersonation } from "@/types"

// IMP-250: persistent bar shown across the whole app while an admin is
// impersonating a client/partner user. Fixed to the top with a high z-index so
// it sits above every layout. While active we set `.impersonating` on <html>;
// scoped CSS in application.css offsets in-flow content AND the fixed sidebar
// (which a plain body padding can't move) so nothing hides underneath the bar.
// "Exit impersonation" restores the admin's own session (DELETE /impersonation).
export default function ImpersonationBanner() {
  const { impersonation } = usePage<{
    impersonation?: Impersonation | null
  }>().props

  useEffect(() => {
    if (!impersonation) return
    const root = document.documentElement
    root.classList.add("impersonating")
    return () => root.classList.remove("impersonating")
  }, [impersonation])

  if (!impersonation) return null

  return (
    <div className="fixed inset-x-0 top-0 z-[100] flex h-10 items-center justify-center gap-3 bg-amber-500 px-4 text-sm font-medium text-amber-950 shadow-sm">
      <Eye className="size-4 shrink-0" />
      <span className="truncate">
        Impersonating{" "}
        <span className="font-semibold">{impersonation.name}</span>
      </span>
      <button
        type="button"
        onClick={() => router.delete(impersonation.exit_path)}
        className="shrink-0 rounded-md bg-amber-950/10 px-2.5 py-1 text-xs font-semibold whitespace-nowrap transition-colors hover:bg-amber-950/20"
      >
        Exit impersonation
      </button>
    </div>
  )
}
